import React, { Suspense }  from 'react';
import ReactDOM from 'react-dom';
import Notifications from 'react-notify-toast';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';

import './css/App.css';

import HomeLanding from './landings/home/HomeLanding';
import Unsubscribe from './components/Unsubscribe';
import ChunkLoadErrorBoundary, { lazyWithChunkRecovery } from './components/ChunkLoadErrorBoundary';

const BlogIndex = lazyWithChunkRecovery(() => import('./components/BlogIndex'));
const BlogPost = lazyWithChunkRecovery(() => import('./components/BlogPost'));
const Dashboard = lazyWithChunkRecovery(() => import('./components/Dashboard'));
const PricePost = lazyWithChunkRecovery(() => import('./SEO/price/PricePost'));
const CalculatorPost = lazyWithChunkRecovery(() => import('./SEO/calculator/CalculatorPost'));
const ApiDocumentation = lazyWithChunkRecovery(() => import('./components/documentation/ApiDocumentation'));
const McpLanding = lazyWithChunkRecovery(() => import('./landings/mcp/McpLanding'));
const McpOauthLogin = lazyWithChunkRecovery(() => import('./components/auth/McpOauthLogin'));

const routing = (
  <Router>
    <Notifications />
    <ChunkLoadErrorBoundary>
    <Suspense fallback={
       <div className="bg">
        <section className="mx-5">
          <div className="vh-100">
            <div className="row h-100 justify-content-center align-items-center">
              <div className="col-12 text-center">
                <div className="spinner">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                  </div>
              </div>
            </div>
          </div>
        </section>
      </div>      
      }>
      <Switch>
        <Route exact path="/" component={HomeLanding} />
        <Route exact path="/stripe/success" component={Dashboard} />
        <Route exact path="/stripe/canceled" component={Dashboard} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/mcp" component={McpLanding} />
        <Route exact path="/mcp/oauth/login" component={McpOauthLogin} />
        <Route exact path="/unsubscribe" component={Unsubscribe} />
        <Route exact path="/api-documentation" component={ApiDocumentation} />
        <Route exact path="/blog" component={BlogIndex} />
        <Route exact path="/blog/:url" component={BlogPost} />
        <Route exact path="/kb/:url" component={BlogPost} />
        <Route exact path="/price/:metal/:currency/:modifier?" component={PricePost} />
        <Route exact path="/calculator/:metal/:currency/:modifier?" component={CalculatorPost} />
      </Switch>
    </Suspense>
    </ChunkLoadErrorBoundary>
  </Router>
)

ReactDOM.render(routing, document.getElementById('root'));
